export interface StorageUtil {
    // biome-ignore lint/complexity/noBannedTypes: <explanation>
    discardAccessToken: Function;
    // biome-ignore lint/complexity/noBannedTypes: <explanation>
    getAccessToken: Function;
    // biome-ignore lint/complexity/noBannedTypes: <explanation>
    hasAccessToken: Function;
    // biome-ignore lint/complexity/noBannedTypes: <explanation>
    saveAccessToken: Function;
}

export const configureStorage = () => {
    let storedAccessToken: string | null = null;
    return {
        discardAccessToken: () => {
            storedAccessToken = null;
        },
        getAccessToken: () => storedAccessToken,
        hasAccessToken: () => Boolean(storedAccessToken),
        saveAccessToken: (token: string) => {
            storedAccessToken = token;
        },
    } as StorageUtil;
};

export const extractAccessTokenFromWindowLocation = (window?: Window) => {
    if (!window || !window.location || !window.location.href) {
        return;
    }

    // biome-ignore lint/suspicious/noImplicitAnyLet: <explanation>
    let token;

    const replacer = (substring: string, arg: string): string => {
        token = arg;
        return substring;
    };

    window.location.href.replace(/access_token=([^&]+)/u, replacer);

    return token;
};

export const configureAccessToken = (window: Window | undefined, storage: StorageUtil) => {
    const urlToken = extractAccessTokenFromWindowLocation(window);

    if (urlToken) {
        storage.saveAccessToken(urlToken);
    }

    return storage;
};

export const accessToken = configureAccessToken(typeof window !== 'undefined' ? window : undefined, configureStorage());
